<div class="wrapper">
    <div class="sidebar-wrapper">
        <div class="sidebar-wrapper-header mt-3">
            <img class="logo" src="../../../../../assets/images/incucai-logo.png" alt="" />
        </div>
        <div class="user-info mt-3">
           Nombre: {{ this.currentUser?.name || "undefined" }} <br>
           Rol: {{ this.currentUser?.currentRole || "undefined" }} <br>
           Org: {{ loadUserInfo() }} <br>
           Pertenece a: <br>
                {{ this.organizations }}
          

        </div>
        <div class="items-wrapper">
            <div class="items-wrapper-top">
                <div *ngIf="currentUser?.organization.isParentOrganization" class="item" [routerLink]="'organizations/'">
                    <i class="fa fa-building-o icon"></i>
                    {{ "landingPage.organizations" | translate }}
                </div>
                <div class="item" [routerLink]="'users/users'">
                    <i class="fa fa-users icon" aria-hidden="true"></i>
                    {{'landingPage.users' | translate}}
                </div>
                <div *ngIf="currentUser?.organization.isParentOrganization" class="item" [routerLink]="'documents/'">
                    <i class="fa fa-file icon" aria-hidden="true"></i>
                    {{'documentsGrid.pageTitle' | translate}}
                </div>
                <div class="item" [routerLink]="'verification/'">
                    <i class="fa fa-shield icon" aria-hidden="true"></i>
                    {{'verification.pageTitle' | translate}}
                </div>
                <div *ngIf="currentUser?.organization.isParentOrganization" class="item" [routerLink]="'users/patients'">
                    <i class="fa fa-users icon" aria-hidden="true"></i>
                    {{'landingPage.patients' | translate}}
                </div>
                <div *ngIf="currentUser?.organization.isParentOrganization" class="item" [routerLink]="'user-management/'">
                    <i class="fa fa-envelope icon" aria-hidden="true"></i>
                    {{'landingPage.userManagement' | translate}}
                </div>
                <div *ngIf="currentUser?.organization.isParentOrganization" class="item" [routerLink]="'alert-config/'">
                    <i class="fa fa-clock-o icon" aria-hidden="true"></i>
                    Firmas pendientes
                </div>
            </div>
            <div class="items-wrapper-rsk" style="margin-top: auto;">
                <img class="logo" src="../../../../../assets/images/rsk_cuted.png" alt="" />
            </div>
            <div class="items-wrapper-bottom">
                <div class="item item-exit" (click)="logout()">
                    <i class="fa fa-sign-out icon"></i>
                    {{ "landingPage.Logout" | translate }}
                </div>
            </div>
        </div>
    </div>

    <div class="content">
        <router-outlet></router-outlet>
    </div>
</div>